import { render, staticRenderFns } from "./mapBoard.vue?vue&type=template&id=8ebb73d2&scoped=true&"
import script from "./mapBoard.vue?vue&type=script&lang=js&"
export * from "./mapBoard.vue?vue&type=script&lang=js&"
import style0 from "./mapBoard.vue?vue&type=style&index=0&id=8ebb73d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb73d2",
  null
  
)

export default component.exports